import React from 'react';
import { Badge } from '@/components/ui/badge';
import { 
  GraduationCap, 
  Shield, 
  Heart, 
  BookOpen,
  Info,
  Sparkles
} from 'lucide-react';

/**
 * Content Category Label Component
 * Shows the type/purpose of health content
 * 
 * @param {string} category - Content category (EDUCATION, PREVENTIVE, LIFESTYLE, AWARENESS, AI_INSIGHT, GENERAL)
 * @param {string} size - Label size (sm, md, lg)
 * @param {boolean} showIcon - Show category icon
 */
const ContentCategoryLabel = ({ 
  category = 'GENERAL',
  size = 'sm',
  showIcon = true 
}) => {
  const categories = {
    EDUCATION: {
      label: 'General Health Education',
      icon: GraduationCap,
      color: 'bg-amber-50 text-amber-700 border-amber-200',
      iconColor: 'text-amber-600'
    },
    PREVENTIVE: {
      label: 'Preventive Guidance',
      icon: Shield,
      color: 'bg-green-50 text-green-700 border-green-200',
      iconColor: 'text-green-600'
    },
    LIFESTYLE: {
      label: 'Lifestyle Support',
      icon: Heart,
      color: 'bg-pink-50 text-pink-700 border-pink-200',
      iconColor: 'text-pink-600'
    },
    AWARENESS: {
      label: 'For Awareness Only',
      icon: Info,
      color: 'bg-blue-50 text-blue-700 border-blue-200',
      iconColor: 'text-blue-600'
    },
    AI_INSIGHT: {
      label: 'AI-Generated Insight',
      icon: Sparkles,
      color: 'bg-purple-50 text-purple-700 border-purple-200',
      iconColor: 'text-purple-600'
    },
    GENERAL: {
      label: 'Wellness Information',
      icon: BookOpen,
      color: 'bg-gray-50 text-gray-700 border-gray-200',
      iconColor: 'text-gray-600'
    }
  };

  const cat = categories[category] || categories.GENERAL;
  const Icon = cat.icon;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5'
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  return (
    <Badge 
      variant="outline" 
      className={`${cat.color} ${sizeClasses[size]} inline-flex items-center gap-1.5 font-medium border`}
    >
      {showIcon && <Icon className={`${iconSizes[size]} ${cat.iconColor}`} />}
      {cat.label}
    </Badge>
  );
};

export default ContentCategoryLabel;
